import React from 'react';

import {AlertActions} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {MinimumIntervalActionsProps} from '../types';

const {selectNewDate} = translations['pt-br'].privateFlow.therapyBooking.actionText;

export function MinimumIntervalActions({handleAction}: MinimumIntervalActionsProps) {
	return <AlertActions primaryAction={handleAction} primaryText={selectNewDate} />;
}
